import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';

const DOCUMENT_TITLE = 'Tax Roll Work File';
export const taxRollWorkFileRoutes = [
  {
    path: '/tax/trworkfile',
    name: 'TR-Work-File',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/taxRollWorkFile.vue'),
    children: [
      {
        path: 'createTRWorkFile',
        name: 'Tax - Tax Roll Work File - Create',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/trworkfile/createTRWorkFileMain.vue'),
      },
      {
        path: 'browse',
        name: 'Tax - Tax Roll Work File - Browse',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/trworkfile/BrowseTrWorkFile.vue'),
      },
      {
        path: 'FeeManagement',
        name: 'Tax - Tax Roll Work File - FeeManagement',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/trworkfile/FeeManagmentMain.vue'),
      },
    ],
  },
];

taxRollWorkFileRoutes.forEach((element, index) => {
  taxRollWorkFileRoutes[index].beforeEnter = async (to, from, next) => {
    await accessCriteria([...authRoles.TaxRead, ...authRoles.TaxAuth], next);
  };
});

export default taxRollWorkFileRoutes;
